import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import heroVisual from '@/assets/antioch-report-dashboard.png.asset.json';

const HeroSection = () => {
  return (
    <section className="bg-fordje-gray-light relative overflow-hidden">
      {/* Ambient glow behind the dashboard */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-100/50 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-indigo-50/50 rounded-full blur-[120px]" />
      </div>

      <div className="container-custom relative z-10 pt-32 md:pt-40 pb-16 md:pb-24">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-fordje-navy mb-6 animate-fade-in leading-[1.1] text-3xl md:text-4xl lg:text-[2.75rem] xl:text-5xl">
            Every local regulation and utility requirement for your{' '}
            <span className="gradient-text">clean energy projects</span>
          </h1>


          <p
            className="text-base md:text-lg text-fordje-navy-light mb-10 max-w-2xl mx-auto leading-relaxed animate-fade-in"
            style={{ animationDelay: '0.1s' }}
          >
            Fordje gives solar, storage, and EV teams every requirement for a jurisdiction, from feasibility through inspection. Instant reports, web app, or API.
          </p>

          <div className="animate-fade-in" style={{ animationDelay: '0.15s' }}>
            <Link to="/request-demo">
              <Button
                size="lg"
                className="text-lg px-8 py-6 bg-gradient-to-r from-fordje-blue to-fordje-accent hover:from-fordje-blue-dark hover:to-fordje-blue shadow-lg shadow-fordje-blue/20"
              >
                Book a Demo <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>

        {/* Dashboard asset */}
        <div
          className="relative max-w-5xl mx-auto mt-16 md:mt-20 animate-fade-in"
          style={{ animationDelay: '0.25s' }}
        >
          <div className="relative aspect-[16/10] rounded-lg bg-white shadow-[0_32px_64px_-16px_rgba(15,23,42,0.12)] border border-slate-200/60 overflow-hidden ring-1 ring-inset ring-white/40">
            <img
              src={heroVisual.url}
              alt="Fordje comprehensive jurisdiction report for Antioch, CA showing solar design standards, BESS design, permitting, and interconnection data"
              width={1920}
              height={1253}
              loading="eager"
              decoding="async"
              fetchPriority="high"
              className="w-full h-full object-cover"
            />
            {/* Fade to show the report continues */}
            <div className="absolute inset-x-0 bottom-0 h-[30%] bg-gradient-to-t from-fordje-gray-light via-fordje-gray-light/80 to-transparent pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
